import { S_COMMON_VALIDATOR } from '@/utils/web-storage-keys';
import { FormPatternValidator, FormPatternValidatorFields } from '@/types/form/validator';
import utils from '@/utils';
import { webStorage } from '@/utils/web-storage';
import { GQItemQueryResult } from '@/types/graphql';
import { getItemQuery } from '@/graphql';
import { setUpGraphQLClient } from '@/lib/graphql/client';
import services from '@/services/index';

export const getPatternValidator = async (name: string) => {
  const cache: Record<string, any> = webStorage.get(S_COMMON_VALIDATOR) || {};
  const nk = name as keyof typeof cache;
  if (!cache[nk]) {
    const path = `/sitecore/content/probio-portal/Configurations/Form Validators/${name}`;
    const item = await services.graphql.getItem<FormPatternValidatorFields>(path);
    console.log('item', item);
    cache[nk] = item;
    webStorage.set(S_COMMON_VALIDATOR, cache);
  }
  return cache[nk];
};
